export const expertsData = [
  {
    id: "1",
    name: "Алексей Петров",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773964552684.png/professional-business-man-portrait-with-confident-expression-warm-lighting-clean-background-corporate-headshot-style-allow-only-white-person-european-800x800.webp?search_term=professional,man,business,portrait&img_prompt=Professional+business+man+portrait+with+confident+expression+warm+lighting+clean+background+corporate+headshot+style&w=400&h=400&type=image",
    title: "Chief Marketing Officer",
    type: "expert",
    specializations: ["Маркетинг", "Бренд-стратегия", "Digital"],
    experience: 12,
    rating: 4.9,
    hourlyRate: 15000,
    bio: "12 лет опыта в digital-маркетинге и построении брендов. Работал с компаниями от стартапов до международных корпораций. Специализируюсь на growth-маркетинге и построении маркетинговых команд.",
    companies: [
      { name: "Яндекс", position: "Head of Marketing", years: "2020-2024" },
      { name: "Тинькофф", position: "Marketing Director", years: "2017-2020" },
      { name: "Mail.ru Group", position: "Senior Marketing Manager", years: "2014-2017" }
    ],
    achievements: [
      "Увеличил конверсию на 340% для финтех-стартапа",
      "Построил маркетинговую команду из 25 человек",
      "Запустил 50+ успешных рекламных кампаний"
    ],
    reviews: [
      { author: "Михаил К.", rating: 5, text: "Алексей помог переосмыслить нашу маркетинговую стратегию. Очень структурный подход.", date: "2024-01-15" },
      { author: "Анна С.", rating: 5, text: "Отличная консультация по запуску нового продукта. Много практических советов.", date: "2024-01-10" },
      { author: "Дарья В.", rating: 5, text: "Превосходная консультация. Алексей быстро разобрался в нашей ситуации и предложил конкретные шаги.", date: "2024-01-05" },
      { author: "Олег Н.", rating: 4, text: "Хорошие рекомендации по digital-стратегии. Уже внедрили несколько идей.", date: "2023-12-28" },
      { author: "Светлана Р.", rating: 5, text: "Алексей помог выстроить воронку продаж. Конверсия выросла за первый месяц.", date: "2023-12-20" },
      { author: "Артём Б.", rating: 5, text: "Очень глубокое понимание рынка. Рекомендую для всех, кто строит бренд.", date: "2023-12-15" },
      { author: "Наталья М.", rating: 4, text: "Полезная сессия по контент-стратегии. Получила план на 3 месяца вперёд.", date: "2023-12-10" }
    ],
    available: true
  },
  {
    id: "2",
    name: "Мария Иванова",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773964552761.png/professional-business-woman-portrait-confident-smile-warm-lighting-clean-background-corporate-headshot-style-allow-only-white-person-european-800x800.webp?search_term=professional,woman,business,portrait&img_prompt=Professional+business+woman+portrait+confident+smile+warm+lighting+clean+background+corporate+headshot+style&w=400&h=400&type=image",
    title: "Product Manager",
    type: "expert",
    specializations: ["Продакт-менеджмент", "UX", "Аналитика"],
    experience: 8,
    rating: 4.8,
    hourlyRate: 12000,
    bio: "Product Manager с опытом в IT и e-commerce. Помогаю находить product-market fit и строить продуктовые процессы. Фанат data-driven подхода.",
    companies: [
      { name: "Ozon", position: "Senior Product Manager", years: "2021-2024" },
      { name: "Авито", position: "Product Manager", years: "2018-2021" },
      { name: "Lamoda", position: "Junior PM", years: "2016-2018" }
    ],
    achievements: [
      "Увеличила retention на 45% через улучшение онбординга",
      "Запустила 3 успешных продукта с нуля",
      "Внедрила OKR-систему в продуктовую команду"
    ],
    reviews: [
      { author: "Дмитрий П.", rating: 5, text: "Мария отлично разбирается в продуктовых метриках. Помогла выстроить аналитику.", date: "2024-01-20" },
      { author: "Алексей Т.", rating: 5, text: "Мария помогла переосмыслить весь продуктовый цикл. Очень системный подход.", date: "2024-01-12" },
      { author: "Ирина Л.", rating: 4, text: "Хорошие советы по UX-исследованиям и приоритизации бэклога.", date: "2024-01-05" },
      { author: "Сергей Д.", rating: 5, text: "Отличная структура консультации. За час получил чёткий план действий.", date: "2023-12-22" },
      { author: "Екатерина П.", rating: 5, text: "Мария помогла найти product-market fit. Бесценный опыт.", date: "2023-12-15" }
    ],
    available: true
  },
  {
    id: "3",
    name: "Сергей Козлов",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773964552676.png/professional-executive-man-portrait-serious-expression-warm-lighting-clean-background-corporate-headshot-style-allow-only-white-person-european-800x800.webp?search_term=professional,man,executive,portrait&img_prompt=Professional+executive+man+portrait+serious+expression+warm+lighting+clean+background+corporate+headshot+style&w=400&h=400&type=image",
    title: "CEO и основатель",
    type: "practitioner",
    specializations: ["Менеджмент", "Стратегия", "Инвестиции"],
    experience: 15,
    rating: 5.0,
    hourlyRate: 25000,
    bio: "Серийный предприниматель, основал 4 компании. Ментор в акселераторах. Помогаю стартапам с бизнес-моделью и привлечением инвестиций. Делюсь реальным опытом, а не теорией.",
    companies: [
      { name: "TechVenture", position: "CEO и основатель", years: "2019-2024" },
      { name: "StartupHub", position: "Сооснователь", years: "2015-2019" },
      { name: "McKinsey", position: "Associate", years: "2010-2015" }
    ],
    achievements: [
      "Привлёк $5M инвестиций для портфельных компаний",
      "Exit на $20M со вторым стартапом",
      "Провёл 200+ стратегических сессий"
    ],
    reviews: [
      { author: "Игорь В.", rating: 5, text: "Сергей помог подготовиться к раунду инвестиций. Закрыли раунд за 2 месяца.", date: "2024-01-25" },
      { author: "Елена М.", rating: 5, text: "Очень ценные инсайты по бизнес-модели.", date: "2024-01-18" },
      { author: "Максим К.", rating: 5, text: "Сергей показал, как правильно структурировать pitch deck. Инвесторы оценили.", date: "2024-01-10" },
      { author: "Ольга П.", rating: 5, text: "Реальный предприниматель, который говорит на языке бизнеса. Без воды.", date: "2024-01-03" },
      { author: "Андрей С.", rating: 5, text: "Помог разобраться с unit-экономикой и найти точки роста.", date: "2023-12-27" },
      { author: "Татьяна Н.", rating: 5, text: "Бесценный опыт масштабирования. Сергей знает, о чём говорит.", date: "2023-12-20" }
    ],
    available: true
  },
  {
    id: "4",
    name: "Ольга Смирнова",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773964552803.png/professional-woman-manager-portrait-friendly-expression-warm-lighting-clean-background-corporate-headshot-style-allow-only-white-person-european-800x800.webp?search_term=professional,woman,manager,portrait&img_prompt=Professional+woman+manager+portrait+friendly+expression+warm+lighting+clean+background+corporate+headshot+style&w=400&h=400&type=image",
    title: "HR Director",
    type: "expert",
    specializations: ["HR", "Команды", "Культура"],
    experience: 10,
    rating: 4.7,
    hourlyRate: 10000,
    bio: "HR-директор с фокусом на построение команд и корпоративную культуру. Помогаю нанимать правильных людей и строить процессы, которые работают.",
    companies: [
      { name: "VK", position: "HR Director", years: "2020-2024" },
      { name: "Сбер", position: "Head of Talent Acquisition", years: "2016-2020" },
      { name: "HeadHunter", position: "HR Manager", years: "2014-2016" }
    ],
    achievements: [
      "Построила HR-функцию в компании с 0 до 500 человек",
      "Снизила текучесть кадров на 60%",
      "Внедрила систему performance review"
    ],
    reviews: [
      { author: "Наталья К.", rating: 5, text: "Ольга помогла выстроить процесс найма. Теперь находим кандидатов в 2 раза быстрее.", date: "2024-01-22" },
      { author: "Виктор А.", rating: 4, text: "Полезные рекомендации по построению команды. Применили стратегию найма.", date: "2024-01-14" },
      { author: "Марина С.", rating: 5, text: "Ольга помогла внедрить систему мотивации. Команда стала продуктивнее.", date: "2024-01-08" },
      { author: "Денис Р.", rating: 5, text: "Отличные советы по корпоративной культуре и удержанию сотрудников.", date: "2023-12-29" }
    ],
    available: false
  },
  {
    id: "5",
    name: "Андрей Волков",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773964552679.png/professional-tech-man-portrait-modern-look-warm-lighting-clean-background-corporate-headshot-style-allow-only-white-person-european-800x800.webp?search_term=professional,man,tech,portrait&img_prompt=Professional+tech+man+portrait+modern+look+warm+lighting+clean+background+corporate+headshot+style&w=400&h=400&type=image",
    title: "Growth Lead",
    type: "expert",
    specializations: ["Growth", "Performance", "Аналитика"],
    experience: 7,
    rating: 4.9,
    hourlyRate: 14000,
    bio: "Growth-маркетолог с опытом в B2B и B2C продуктах. Специализируюсь на performance-маркетинге, A/B тестировании и построении воронок.",
    companies: [
      { name: "Miro", position: "Growth Lead", years: "2021-2024" },
      { name: "Notion", position: "Growth Manager", years: "2019-2021" },
      { name: "Amplitude", position: "Marketing Analyst", years: "2017-2019" }
    ],
    achievements: [
      "Вырастил MAU с 100K до 1M пользователей",
      "Снизил CAC на 55% через оптимизацию каналов",
      "Построил attribution-модель с нуля"
    ],
    reviews: [
      { author: "Павел Д.", rating: 5, text: "Андрей дал конкретные рекомендации по growth-стратегии.", date: "2024-01-28" },
      { author: "Ксения Л.", rating: 5, text: "Отличное понимание аналитики и метрик. Очень полезная консультация.", date: "2024-01-12" },
      { author: "Роман Г.", rating: 5, text: "Андрей помог настроить A/B тестирование. Конверсия выросла на 30%.", date: "2024-01-05" },
      { author: "Лариса К.", rating: 4, text: "Хорошие инсайты по performance-маркетингу и оптимизации бюджета.", date: "2023-12-30" },
      { author: "Илья М.", rating: 5, text: "Построили воронку с нуля за одну сессию. Андрей знает своё дело.", date: "2023-12-22" }
    ],
    available: true
  },
  {
    id: "6",
    name: "Екатерина Морозова",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773964552665.png/professional-creative-woman-portrait-artistic-expression-warm-lighting-clean-background-corporate-headshot-style-allow-only-white-person-european-800x800.webp?search_term=professional,woman,creative,portrait&img_prompt=Professional+creative+woman+portrait+artistic+expression+warm+lighting+clean+background+corporate+headshot+style&w=400&h=400&type=image",
    title: "Creative Director",
    type: "expert",
    specializations: ["Креатив", "Бренд", "Коммуникации"],
    experience: 11,
    rating: 4.8,
    hourlyRate: 16000,
    bio: "Креативный директор с опытом в рекламных агентствах и на стороне клиента. Помогаю создавать запоминающиеся бренды и коммуникационные стратегии.",
    companies: [
      { name: "BBDO", position: "Creative Director", years: "2020-2024" },
      { name: "Leo Burnett", position: "Senior Art Director", years: "2016-2020" },
      { name: "Студия Лебедева", position: "Art Director", years: "2013-2016" }
    ],
    achievements: [
      "Каннские львы: 2 золота, 3 серебра",
      "Ребрендинг для 15+ компаний",
      "Создала визуальную идентичность для топ-5 российских брендов"
    ],
    reviews: [
      { author: "Роман С.", rating: 5, text: "Екатерина помогла найти уникальный визуальный язык для бренда.", date: "2024-01-30" },
      { author: "Анна В.", rating: 5, text: "Креативный подход к брендингу. Екатерина видит то, чего не замечают другие.", date: "2024-01-20" },
      { author: "Михаил Т.", rating: 4, text: "Сильная экспертиза в визуальных коммуникациях. Помогла с айдентикой.", date: "2024-01-12" },
      { author: "Дарья К.", rating: 5, text: "Потрясающая работа над коммуникационной стратегией. Всё чётко и по делу.", date: "2024-01-05" }
    ],
    available: true
  },
  {
    id: "7",
    name: "Дмитрий Самойлов",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773965566673.png/professional-man-in-casual-business-attire-with-warm-friendly-expression-natural-lighting-clean-background-candid-business-portrait-allow-only-white-person-european-800x800.webp?search_term=professional,man,business,casual&img_prompt=Professional+man+in+casual+business+attire+with+warm+friendly+expression+natural+lighting+clean+background+candid+business+portrait&w=400&h=400&type=image",
    title: "Основатель сети кофеен",
    type: "practitioner",
    specializations: ["Менеджмент", "Операционка", "Франчайзинг"],
    experience: 9,
    rating: 4.7,
    hourlyRate: 8000,
    bio: "Основатель сети из 12 кофеен. Прошёл путь от одной точки до франшизы. Знаю реальную боль малого бизнеса изнутри, а не из учебников. Готов обсудить операционку, найм, поставщиков и масштабирование.",
    companies: [
      { name: "CoffeePoint", position: "Основатель", years: "2016-2024" },
      { name: "Retail Solutions", position: "Операционный менеджер", years: "2013-2016" }
    ],
    achievements: [
      "Масштабировал бизнес с 1 до 12 точек за 5 лет",
      "Запустил франшизу с 4 партнёрами",
      "Средний чек вырос на 35% через оптимизацию меню"
    ],
    reviews: [
      { author: "Алина Р.", rating: 5, text: "Дмитрий рассказал про реальные подводные камни масштабирования. Бесценно.", date: "2024-02-01" },
      { author: "Георгий К.", rating: 5, text: "Очень практичный разговор о франчайзинге. Без теории, только реальный опыт.", date: "2024-01-22" },
      { author: "Марина Д.", rating: 4, text: "Помог разобраться с операционными процессами. Дал шаблоны и чек-листы.", date: "2024-01-15" }
    ],
    available: true
  },
  {
    id: "8",
    name: "Наталья Быкова",
    avatar: "https://content-studio.biela.dev/cover/800x800/i/images-library/69b1c43fe2c338fda004d723/1773963929241-69b1c43fe2c338fda004d723/originals/1773965566772.png/professional-woman-entrepreneur-portrait-with-confident-warm-expression-natural-indoor-lighting-clean-modern-background-corporate-candid-style-allow-only-white-person-european-800x800.webp?search_term=professional,woman,entrepreneur,portrait&img_prompt=Professional+woman+entrepreneur+portrait+with+confident+warm+expression+natural+indoor+lighting+clean+modern+background+corporate+candid+style&w=400&h=400&type=image",
    title: "Директор по маркетингу, производство",
    type: "practitioner",
    specializations: ["Маркетинг", "B2B", "Производство"],
    experience: 14,
    rating: 4.9,
    hourlyRate: 11000,
    bio: "14 лет в маркетинге промышленных компаний. Знаю, как продвигать сложные B2B-продукты, выстраивать дилерские сети и работать с длинным циклом сделки. Практик, не теоретик.",
    companies: [
      { name: "ТехноПром", position: "Директор по маркетингу", years: "2018-2024" },
      { name: "Металлург-Сервис", position: "Руководитель отдела продаж", years: "2012-2018" }
    ],
    achievements: [
      "Выстроила дилерскую сеть в 30+ регионах",
      "Увеличила выручку направления в 3 раза за 4 года",
      "Внедрила CRM и автоматизировала воронку продаж"
    ],
    reviews: [
      { author: "Константин Г.", rating: 5, text: "Наталья дала конкретный план по выходу на новые рынки. Очень практично.", date: "2024-01-30" },
      { author: "Владимир С.", rating: 5, text: "Наталья знает B2B-маркетинг как никто. Помогла выстроить дилерскую сеть.", date: "2024-01-20" },
      { author: "Елена Б.", rating: 4, text: "Ценные советы по автоматизации продаж и CRM для промышленного бизнеса.", date: "2024-01-10" },
      { author: "Алексей Г.", rating: 5, text: "Наталья помогла найти подход к длинному циклу B2B-сделки. Результат налицо.", date: "2023-12-28" }
    ],
    available: true
  }
];

export const specializations = [
  "Маркетинг",
  "Digital",
  "Бренд-стратегия",
  "Продакт-менеджмент",
  "UX",
  "Аналитика",
  "Менеджмент",
  "Стратегия",
  "Инвестиции",
  "HR",
  "Команды",
  "Культура",
  "Growth",
  "Performance",
  "Креатив",
  "Коммуникации",
  "Операционка",
  "Франчайзинг",
  "B2B",
  "Производство"
];

export const experienceLevels = [
  { label: "1-3 года", min: 1, max: 3 },
  { label: "3-5 лет", min: 3, max: 5 },
  { label: "5-10 лет", min: 5, max: 10 },
  { label: "10+ лет", min: 10, max: 100 }
];

export const personTypes = [
  { id: "all", label: "Все" },
  { id: "expert", label: "Эксперты" },
  { id: "practitioner", label: "Предприниматели" }
];
